import { render } from "./SupportButton.vue?vue&type=template&id=2949c74b&scoped=true"
import script from "./SupportButton.vue?vue&type=script&lang=js"
export * from "./SupportButton.vue?vue&type=script&lang=js"

import "./SupportButton.vue?vue&type=style&index=0&id=2949c74b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2949c74b"]])

export default __exports__